import { render, staticRenderFns } from "./ProfileCheckbox.vue?vue&type=template&id=adc9c656&scoped=true&"
import script from "./ProfileCheckbox.vue?vue&type=script&lang=js&"
export * from "./ProfileCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc9c656",
  null
  
)

export default component.exports